import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=349c1c23&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349c1c23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349c1c23')) {
      api.createRecord('349c1c23', component.options)
    } else {
      api.reload('349c1c23', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=349c1c23&scoped=true&", function () {
      api.rerender('349c1c23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/HomePage.vue"
export default component.exports